import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { QuoteListFilter } from '../enums/quoteListFilter'
import { QuoteStatus } from '../enums/quoteStatus'
import { pendingQuoteStatuses } from './pendingQuoteStatuses'

interface QuoteFilterApiParams {
  documentTypes: InvoiceDocumentType[]
  status?: QuoteStatus | QuoteStatus[]
}

export const resolveStatusParam = (status?: QuoteStatus | QuoteStatus[]): string | undefined => {
  if (!status) {
    return undefined
  }
  return Array.isArray(status) ? status.join(',') : status
}

export const quoteListFilterToApiParams: Record<QuoteListFilter, QuoteFilterApiParams> = {
  [QuoteListFilter.All]: { documentTypes: [InvoiceDocumentType.Quote, InvoiceDocumentType.QuoteDraft] },
  [QuoteListFilter.Draft]: { documentTypes: [InvoiceDocumentType.QuoteDraft] },
  [QuoteListFilter.Pending]: {
    documentTypes: [InvoiceDocumentType.Quote],
    status: pendingQuoteStatuses,
  },
  [QuoteListFilter.Accepted]: { documentTypes: [InvoiceDocumentType.Quote], status: QuoteStatus.Accepted },
  [QuoteListFilter.Rejected]: { documentTypes: [InvoiceDocumentType.Quote], status: QuoteStatus.Rejected },
  [QuoteListFilter.Invoiced]: { documentTypes: [InvoiceDocumentType.Quote], status: QuoteStatus.Invoiced },
}
